import classNames from "classnames";
import { ContributeForm } from "./components/ContributeForm/ContributeForm";
import { Info } from "./components/ContributeForm/Info/Info";
import { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import styles from "./App.module.scss";

function App() {
  const isInDevelopment = process.env.NODE_ENV === "development";
  let timeoutHandle;

  const [showForm, setShowForm] = useState(false);
  const [showInfo, setShowInfo] = useState(true);

  const getStartedHandler = () => {
    window.scroll({ top: 0, behavior: "smooth" });
    timeoutHandle = setTimeout(() => setShowInfo(false), 400);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeoutHandle);
    };
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("redirect") === "form") {
      setShowInfo(false);
    }
  }, [setShowInfo]);

  return (
    <div className={classNames("App", { "p-3": isInDevelopment })}>
      <CSSTransition
        in={showInfo}
        classNames={styles}
        timeout={100}
        unmountOnExit
        onExited={() => setShowForm(true)}
      >
        <Info onGetStarted={getStartedHandler} />
      </CSSTransition>
      <CSSTransition
        in={showForm}
        timeout={100}
        classNames={styles}
        unmountOnExit
      >
        <div>
          <p>
            For inspiration see{" "}
            <a
              href={`${process.env.REACT_APP_URL}/facial-flaps/rotation-flap/case-1/`}
              target="_blank"
              rel="noreferrer"
            >
              this example{" "}
            </a>
            of a case on PlastSurgeon. If you have questions please contact our
            team at{" "}
            <a href="mailto:handbookplasticsurgery@gmail.com">
              handbookplasticsurgery@gmail.com
            </a>
            .
          </p>
          <ContributeForm />
        </div>
      </CSSTransition>
    </div>
  );
}

export default App;
